/** Reservado por si hay que reactivar diagnóstico de dibujo; ahora sin salida. */
export const drawSnapLog = (_step: string, _data?: Record<string, unknown>) => {}
